"use client";

import { withFallback } from "../with-fallback";

export const PendingBreakdownElement = withFallback({
	displayName: "PendingBreakdownElement",
	type: "pending-breakdown-element",
} as const);
